import { Box, Chip, Grid2 as Grid, type Theme, Typography } from '@mui/material';
import { SmartReportTypeEnum } from '@/admins/SmartReports/types';
import { REPORT_TYPE_ICONS } from '../SmartReportList/constants';
import { useEditSmartReport } from './EditSmartReportContext';

const styles = {
  subheader: {
    whiteSpace: 'pre-line',
    color: (theme: Theme) => theme.palette.baseColors.deepSeaNavy.c75,
  },
};

export const AssetReportVersion = () => {
  const { report, reportVersion } = useEditSmartReport();
  const reportType = report?.smartReportType?.name || SmartReportTypeEnum.Asset;

  return (
    <Grid container alignItems='center'>
      <Typography sx={styles.subheader} variant='subtitle2' display='flex' alignItems='center'>
        {REPORT_TYPE_ICONS[reportType as keyof typeof REPORT_TYPE_ICONS]}
        <Box component='span' sx={{ margin: '0 0.5em' }}>
          {reportType} Report
        </Box>
        <Chip color='secondary' label={`v${reportVersion?.number}`} sx={{ fontSize: '0.5rem' }} />
      </Typography>
    </Grid>
  );
};
